import React, { useMemo } from "react";
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel
} from "@reach/accordion";
import "@reach/accordion/styles.css";

const Faqs = ({ faq }) => {
  const url = typeof window !== "undefined" ? window.location.pathname : "";
  const showFilter = url === "/personal-savings/" || url === "/savings/";

  const faqItems = useMemo(() => {
    const firstCategory = faq && faq.length ? faq[0] : null;

    if (!firstCategory || !firstCategory.faqs || !firstCategory.faqs.nodes) {
      return [];
    }

    const parentOrderCache = new Map();

    const getParentOrder = parent => {
      const parentId = parent?.id || "";

      if (!parentId) {
        return Number.MAX_SAFE_INTEGER;
      }

      if (!parentOrderCache.has(parentId)) {
        parentOrderCache.set(
          parentId,
          Number.isFinite(Number(parent.menuOrder))
            ? Number(parent.menuOrder)
            : Number.MAX_SAFE_INTEGER
        );
      }

      return parentOrderCache.get(parentId);
    };

    const flatFaqs = firstCategory.faqs.nodes.flatMap(parent =>
      (parent.childFaqs?.nodes || []).map(child => ({
        ...child,
        parentId: parent?.id || "",
        parentMenuOrder: getParentOrder(parent)
      }))
    );

    flatFaqs.sort((left, right) => {
      if (left.parentMenuOrder !== right.parentMenuOrder) {
        return left.parentMenuOrder - right.parentMenuOrder;
      }

      if (left.parentId !== right.parentId) {
        return String(left.parentId).localeCompare(String(right.parentId));
      }

      if (Number(left.menuOrder) !== Number(right.menuOrder)) {
        return Number(left.menuOrder) - Number(right.menuOrder);
      }

      const titleCompare = String(left.title).localeCompare(String(right.title));
      if (titleCompare !== 0) {
        return titleCompare;
      }

      return String(left.id).localeCompare(String(right.id));
    });

    return flatFaqs.slice(0, 16);
  }, [faq]);

  return (
    <>
      <section className="content very-light-blue-background">
        <div className="eighty-spacer"></div>
        <div className="content-block">
          <div className="centered-title-holder">
            <h1 className="staggerFadeInFirst first-load">
              Frequently Asked Questions
            </h1>
          </div>
          <div className="scroll-to-filter"></div>
          <div className="filter-block"></div>
          <div className="faq-list-container">
            {faqItems.length ? (
              <ul className="faqs-mixit-container" id="MixItUp65659F">
                <Accordion collapsible>
                  {faqItems.map((item, index) => (
                    <li className="mix personal-savings" key={index}>
                      <AccordionItem className="mix personal-savings">
                        <div className="c-faq-question-holder">
                          <AccordionButton className="question-text">
                            {item.title}
                            <span className="white-mango-status-icon"></span>
                          </AccordionButton>
                        </div>
                        <AccordionPanel className="c-faq-answer-container">
                          <div
                            className="c-faq-answer-holder"
                            dangerouslySetInnerHTML={{ __html: item.content }}
                          />
                        </AccordionPanel>
                      </AccordionItem>
                    </li>
                  ))}
                </Accordion>
              </ul>
            ) : null}
            {showFilter ? (
              <div className="all-faqs-link staggerFadeIn stag-visible">
                <a href="/faqs/" data-link="personal-savings">
                  All Savings FAQs
                </a>
              </div>
            ) : (
              <div className="all-faqs-link staggerFadeIn stag-visible">
                <a href="/business/faqs-business/" data-link="savings">
                  All Savings FAQs
                </a>
              </div>
            )}
          </div>
        </div>
        <div className="eighty-spacer"></div>
      </section>
    </>
  );
};

export default Faqs;
